import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DataService} from "../../services/data.service";
import {AccessService} from "../../services/access.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";
import {YesNoPipe} from "../../pipes/yes-no.pipe";

@Component({
    selector: 'app-supplier-product-detail',
    imports: [NgIf, ReactiveFormsModule, RouterLink, YesNoPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3>
                        <i class="fa-solid fa-box-open me-2"></i>
                        @switch (viewMode) {
                            @case (ViewMode.INSERT) {
                                Lieferantenprodukt anlegen
                            }
                            @case (ViewMode.EDIT) {
                                Lieferantenprodukt bearbeiten
                            }
                            @case (ViewMode.VIEW) {
                                Lieferantenprodukt
                            }
                        }
                    </h3>
                </div>

                <form [formGroup]="form">
                    <h5 class="mt-2">Zuordnung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-6">
                            <label>Lieferant</label>
                            <select class="form-control" formControlName="id_supplier" *ngIf="viewMode != ViewMode.VIEW">
                                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                                @for (supplier of suppliers; track supplier.id) {
                                    <option [ngValue]="supplier.id">
                                        {{ supplier.name }}
                                    </option>
                                }
                            </select>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">
                                <a [routerLink]="['/supplier/', form.value.id_supplier]">{{ form.value.supplier }}</a>
                            </p>
                        </div>
                    </div>

                    <h5>Bezeichnung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Name</label>
                            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.name }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Beschreibung</label>
                            <input type="text" class="form-control" formControlName="description" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.description }}</p>
                        </div>
                    </div>

                    <h5>Nummern</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>EAN</label>
                            <input type="text" class="form-control" formControlName="EAN" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.EAN }}</p>
                        </div>
                        <div class="col-6 col-lg-4">
                            <label>Nummer</label>
                            <input type="text" class="form-control" formControlName="number" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.number }}</p>
                        </div>
                    </div>

                    <h5>Verpackung</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Verpackungsanzahl</label>
                            <input type="text" class="form-control" formControlName="package_amount" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.package_amount }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Verpackungseinheit</label>
                            <input type="text" class="form-control" formControlName="package_unit" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.package_unit }}</p>
                        </div>
                    </div>

                    <h5>Diverses</h5>
                    <div class="row g-3 align-items-end mb-3">
                        <div class="col-12 col-lg-4">
                            <label>Tags</label>
                            <input type="text" class="form-control" formControlName="tags" *ngIf="viewMode != ViewMode.VIEW">
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.tags }}</p>
                        </div>
                        <div class="col-12 col-lg-4">
                            <label>Aktiv</label>
                            <div *ngIf="viewMode != ViewMode.VIEW">
                                <input type="checkbox" class="form-check-input" formControlName="active">
                            </div>
                            <p *ngIf="viewMode == ViewMode.VIEW" class="mb-0">{{ form.value.active | yesNo }}</p>
                        </div>
                    </div>

                    <h5>Allergene</h5>
                    <div class="row g-3 mb-3">
                        @if (viewMode != ViewMode.VIEW) {
                            @for (allergen of allergens; track allergen.id) {
                                <div class="col-12 col-md-4 col-lg-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"
                                               [id]="'allergen_' + allergen.id"
                                               [checked]="isAllergenSelected(allergen.id)"
                                               (change)="onAllergenChange(allergen.id, $event)">
                                        <label class="form-check-label" [for]="'allergen_' + allergen.id">
                                            ({{ allergen.code }}) {{ allergen.name }}
                                        </label>
                                    </div>
                                </div>
                            } @empty {
                                <p class="mb-0">Keine Allergene verfügbar</p>
                            }
                        } @else {
                            @for (allergen of getSelectedAllergens(); track allergen.id) {
                                <div class="col-12 col-md-4 col-lg-3">
                                    <p class="mb-0">
                                        ({{ allergen.code }}) {{ allergen.name }}
                                    </p>
                                </div>
                            } @empty {
                                <p class="mb-0">Keine Allergene gesetzt</p>
                            }
                        }
                    </div>

                    <h5>Bild</h5>
                    <div class="row g-3 align-items-end">
                        <div class="col-12 col-lg-6">
                            <label>Produktbild</label>
                            <input type="file" class="form-control" accept="image/*" (change)="onImageSelected($event)" *ngIf="viewMode != ViewMode.VIEW">
                            <div *ngIf="selectedImage || product?.image_hash" class="mt-2">
                                <img [src]="selectedImage || product?.file_path + product?.image_hash" alt="Product Image" style="max-width: 200px; max-height: 200px;">
                            </div>
                        </div>
                    </div>
                </form>

                <div class="mt-3 d-flex flex-wrap justify-content-between gap-2">
                    @if (viewMode == ViewMode.VIEW) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
                            <button type="button" class="btn btn-danger" (click)="delete()">Löschen</button>
                        </div>
                    } @else if (viewMode == ViewMode.EDIT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
                            <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Abbrechen</button>
                        </div>
                    } @else if (viewMode == ViewMode.INSERT) {
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">Speichern</button>
                            <button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
                        </div>
                    }
                </div>

            </div>
        </div>
    `
})
export class SupplierProductDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_product!: string;
    viewMode!: ViewMode;
    product: any;
    selectedImage: string | null = null;

    suppliers!: any[];
    allergens!: any[];

    ngOnInit(): void {
        this.id_product = this.route.snapshot.paramMap.get('id') ?? '0';
        this.viewMode = this.id_product == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_supplier: ['', Validators.required],
            name: [null, Validators.required],
            description: [null, Validators.required],
            EAN: [null, Validators.required],
            number: [null, Validators.required],
            package_amount: [null, Validators.required],
            package_unit: [null, Validators.required],
            tags: [null],
            active: [true],
            image: null,
            allergens: [[]],

            supplier: [null],
        });

        if (this.id_product !== '0') {
            this.getProduct();
        }

        this.dataService.request("Supplier/listForSelection").subscribe(response => {
            this.suppliers = response.suppliers;
        });

        this.dataService.request("SupplierProduct/listAllergens").subscribe(response => {
            this.allergens = response.allergens;
        });
    }

    getProduct(): void {
        this.dataService.request('SupplierProduct/get', {
            id_product: this.id_product
        }).subscribe(response => {
            this.product = response.product;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.product.id,
            id_supplier: this.product.id_supplier,
            name: this.product.name,
            description: this.product.description,
            EAN: this.product.EAN,
            number: this.product.number,
            package_amount: this.product.package_amount,
            package_unit: this.product.package_unit,
            tags: this.product.tags,
            active: this.product.active == 1,
            allergens: this.product.allergens || [],
            image: null,

            supplier: this.product.supplier,
        });
    }

    save(): void {
        this.dataService.request('SupplierProduct/save', {
            product: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/supplierproduct']);
            this.toastrService.success('Das Lieferantenprodukt wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('SupplierProduct/update', {
            product: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getProduct();
            this.toastrService.success('Das Lieferantenprodukt wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/supplierproduct']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getProduct();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Das Lieferantenprodukt wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('SupplierProduct/delete', {
                    id_product: this.id_product
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Das Lieferantenprodukt wurde gelöscht');
                });
            }
        });
    }

    onImageSelected(event: Event): void {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                this.selectedImage = reader.result as string;
                this.form.patchValue({
                    image: reader.result as string
                });
            };
            reader.readAsDataURL(file);
        }
    }

    isAllergenSelected(id: number): boolean {
        return this.form.get('allergens')?.value?.includes(id);
    }

    onAllergenChange(id: number, event: any): void {
        const allergens = this.form.get('allergens')?.value as number[];
        if (event.target.checked) {
            this.form.patchValue({ allergens: [...allergens, id] });
        } else {
            this.form.patchValue({ allergens: allergens.filter(a => a !== id) });
        }
    }

    getSelectedAllergens(): any[] {
        return this.allergens?.filter(a => this.isAllergenSelected(a.id)) || [];
    }
}
